import React from 'react';
import { IconSvgProps } from '@models/common';

const More: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.7334 12H4.7434M11.7334 12H11.7434M18.7334 12H18.7434M5.7334 12C5.7334 12.5523 5.28568 13 4.7334 13C4.18111 13 3.7334 12.5523 3.7334 12C3.7334 11.4477 4.18111 11 4.7334 11C5.28568 11 5.7334 11.4477 5.7334 12ZM12.7334 12C12.7334 12.5523 12.2857 13 11.7334 13C11.1811 13 10.7334 12.5523 10.7334 12C10.7334 11.4477 11.1811 11 11.7334 11C12.2857 11 12.7334 11.4477 12.7334 12ZM19.7334 12C19.7334 12.5523 19.2857 13 18.7334 13C18.1811 13 17.7334 12.5523 17.7334 12C17.7334 11.4477 18.1811 11 18.7334 11C19.2857 11 19.7334 11.4477 19.7334 12Z'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default More;
